import dayjs from 'dayjs'
import { residentHealthRecordsConstants } from 'locale/residentHealthRecords'
import { CommunicationStatus } from './types'

// Re-export CommunicationStatus for convenience
export { CommunicationStatus }

type CommunicationStatusType = CommunicationStatus

export const formatDate = (dateString?: string): string => {
  if (!dateString) return ''
  return dayjs(dateString).format('DD-MM-YYYY')
}

export const getStatusLabel = (
  status?: string | CommunicationStatusType
): string => {
  if (!status) return ''
  const statusLabelMap: Record<string, string> = {
    [CommunicationStatus.PREPARATION]:
      residentHealthRecordsConstants.STATUS_PREPARATION,
    [CommunicationStatus.COMPLETED]:
      residentHealthRecordsConstants.STATUS_COMPLETED,
    [CommunicationStatus.ENTERED_IN_ERROR]:
      residentHealthRecordsConstants.STATUS_ENTERED_IN_ERROR,
    [CommunicationStatus.IN_PROGRESS]:
      residentHealthRecordsConstants.STATUS_IN_PROGRESS,
    [CommunicationStatus.NOT_DONE]:
      residentHealthRecordsConstants.STATUS_NOT_DONE,
    [CommunicationStatus.ON_HOLD]:
      residentHealthRecordsConstants.STATUS_ON_HOLD,
    [CommunicationStatus.STOPPED]:
      residentHealthRecordsConstants.STATUS_STOPPED,
    [CommunicationStatus.UNKNOWN]: residentHealthRecordsConstants.STATUS_UNKNOWN
  }

  return statusLabelMap[status] || status
}

export const getStatusDescription = (
  status?: string | CommunicationStatusType
): string => {
  if (!status) return ''
  const statusDescriptionMap: Record<string, string> = {
    [CommunicationStatus.PREPARATION]:
      residentHealthRecordsConstants.STATUS_PREPARATION_DESCRIPTION,
    [CommunicationStatus.COMPLETED]:
      residentHealthRecordsConstants.STATUS_COMPLETED_DESCRIPTION,
    [CommunicationStatus.ENTERED_IN_ERROR]:
      residentHealthRecordsConstants.STATUS_ENTERED_IN_ERROR_DESCRIPTION,
    [CommunicationStatus.IN_PROGRESS]:
      residentHealthRecordsConstants.STATUS_IN_PROGRESS_DESCRIPTION,
    [CommunicationStatus.NOT_DONE]:
      residentHealthRecordsConstants.STATUS_NOT_DONE_DESCRIPTION,
    [CommunicationStatus.ON_HOLD]:
      residentHealthRecordsConstants.STATUS_ON_HOLD_DESCRIPTION,
    [CommunicationStatus.STOPPED]:
      residentHealthRecordsConstants.STATUS_STOPPED_DESCRIPTION,
    [CommunicationStatus.UNKNOWN]:
      residentHealthRecordsConstants.STATUS_UNKNOWN_DESCRIPTION
  }

  return statusDescriptionMap[status] || ''
}

/**
 * Returns Ant Design Tag preset color for communication status
 * Aligns with Informed Consent status tag colors
 */
export const getStatusTagColor = (
  status?: string | CommunicationStatusType
): string | undefined => {
  if (!status) return 'default'
  const statusTagColorMap: Record<string, string> = {
    [CommunicationStatus.COMPLETED]: 'green',
    [CommunicationStatus.IN_PROGRESS]: 'blue',
    [CommunicationStatus.PREPARATION]: 'orange',
    [CommunicationStatus.ON_HOLD]: 'default',
    [CommunicationStatus.STOPPED]: 'red',
    [CommunicationStatus.NOT_DONE]: 'red',
    [CommunicationStatus.ENTERED_IN_ERROR]: 'red',
    [CommunicationStatus.UNKNOWN]: 'default'
  }

  return statusTagColorMap[status] || 'default'
}
